import * as React from "react";
import StickyNode from "react-stickynode";
const Sticky = ({ children, top, bottomBoundary, enabled }) => (
  // StickyNode expects a Single React element as a child, hence the fragment
  /* @__PURE__ */ React.createElement(StickyNode, { top, bottomBoundary, enabled }, /* @__PURE__ */ React.createElement(React.Fragment, null, children))
);
export {
  Sticky as default
};
//# sourceMappingURL=Sticky.js.map
